class VideoControls extends HTMLElement {
  connectedCallback() {
    this.video = this.parentNode.querySelector('video');
    this.volumeButton = this.querySelector('[volume]');

    if (this.video && this.volumeButton) {
      this.volumeButton.addEventListener('click', this.toggleVolume.bind(this));
    }
  }

  toggleVolume() {
    if (this.video.muted) {
      this.video.muted = false;
    } else {
      this.video.muted = true;
    }
    this.volumeButton.querySelectorAll('span').forEach((span) => span.classList.toggle('hidden'));
  }
}

customElements.define('video-controls', VideoControls);
